<!-- HORIZONTAL / ORDER PRODUCT LIST -->
<div
  *ngIf="orientation === 'landscape'"
  class="order-timeline order-timeline--landscape"
  role="list"
  aria-label="Avance del pedido"
>
  <div
    *ngFor="let step of order.steps; let i = index"
    class="order-timeline__step"
    role="listitem"
  >
    <div class="order-timeline__track">
      <span
        *ngIf="i > 0"
        class="order-timeline__line order-timeline__line--left"
        [class.order-timeline__line--completed]="isLeftSegmentCompleted(i)"
      ></span>

      <span
        *ngIf="i < order.steps.length - 1"
        class="order-timeline__line order-timeline__line--right"
        [class.order-timeline__line--completed]="isRightSegmentCompleted(i)"
      ></span>

      <span
        class="order-timeline__node"
        [class.order-timeline__node--past]="isPastStep(i)"
        [class.order-timeline__node--current]="isCurrentStep(i)"
        [class.order-timeline__node--pending]="isPendingStep(i)"
        [attr.aria-current]="isCurrentStep(i) ? 'step' : null"
      >
        <img
          *ngIf="isCurrentStep(i)"
          [src]="step.icon"
          alt=""
          class="order-timeline__icon"
        />
      </span>
    </div>

    <p
      class="order-timeline__label"
      [class.order-timeline__label--past]="isPastStep(i)"
      [class.order-timeline__label--current]="isCurrentStep(i)"
      [class.order-timeline__label--pending]="isPendingStep(i)"
    >
      {{ step.label }}
    </p>
  </div>
</div>

<!-- VERTICAL / ORDER PRODUCT DETAIL -->
<div
  *ngIf="orientation === 'portrait'"
  class="order-timeline order-timeline--portrait"
  role="list"
  aria-label="Avance del pedido"
>
  <div
    *ngFor="let step of order.steps; let i = index"
    class="order-timeline__portrait-step"
    role="listitem"
  >
    <div class="order-timeline__portrait-track">
      <span
        *ngIf="i > 0"
        class="order-timeline__portrait-line order-timeline__portrait-line--top"
        [class.order-timeline__line--completed]="isLeftSegmentCompleted(i)"
      ></span>

      <span
        *ngIf="i < order.steps.length - 1"
        class="order-timeline__portrait-line order-timeline__portrait-line--bottom"
        [class.order-timeline__line--completed]="isRightSegmentCompleted(i)"
      ></span>

      <span
        class="order-timeline__portrait-node"
        [class.order-timeline__portrait-node--past]="isPastStep(i)"
        [class.order-timeline__portrait-node--current]="isCurrentStep(i)"
        [class.order-timeline__portrait-node--pending]="isPendingStep(i)"
        [attr.aria-current]="isCurrentStep(i) ? 'step' : null"
      >
        <img
          *ngIf="isCurrentStep(i)"
          [src]="step.icon"
          alt=""
          class="order-timeline__portrait-icon"
        />
      </span>
    </div>

    <div class="order-timeline__portrait-copy">
      <h3
        class="order-timeline__portrait-label"
        [class.order-timeline__portrait-label--past]="isPastStep(i)"
        [class.order-timeline__portrait-label--current]="isCurrentStep(i)"
        [class.order-timeline__portrait-label--pending]="isPendingStep(i)"
      >
        {{ step.label }}
      </h3>

      <p
        *ngIf="isCurrentStep(i) && step.description"
        class="order-timeline__description"
      >
        {{ step.description }}
      </p>

      <p
        *ngIf="(isPastStep(i) || isCurrentStep(i)) && step.date"
        class="order-timeline__date"
      >
        {{ step.date }}
      </p>
    </div>
  </div>
</div>
